<template>
  <div class="measure-scale-calibration__container">
    <div class="measure-scale-calibration__measure-x">
      <div
        ref="measureXRef"
        class="measure-x-dynamic"
      />
      <div
        class="label-x-dynamic"
      >
        <span
          class="-mt-2 -mx-1 material-icons measure_label_icon"
        >arrow_drop_up</span>
        <label class="m-0 font-bold">
          Medir la barra sobre la pantalla
        </label>
      </div>
      <InputNumber
        v-model="mmX"
        type="number"
        class="input-x-dynamic mb-2"
        :max-fraction-digits="0"
        :min-fraction-digits="0"
        placeholder="mm horizontales"
        suffix=" mm"
      />
    </div>

    <div class="measure-scale-calibration__measure-y-help-container">
      <div class="measure-scale-calibration__measure-y">
        <div
          ref="measureYRef"
          class="measure-y-dynamic"
        />
        <div class="m-0 flex flex-column justify-content-end">
          <div
            class="label-y-dynamic"
          >
            <span
              class="-mt-2 -mx-2 material-icons measure_label_icon"
            >arrow_left</span>
            <label class="font-bold m-0">
              Medir la barra sobre la pantalla
            </label>
          </div>
          <InputNumber
            v-model="mmY"
            type="number"
            class="input-y-dynamic m-0 ml-2"
            placeholder="mm verticales"
            suffix=" mm"
          />
        </div>
      </div>
      <div class="measure-scale-calibration__help-container">
        <!-- eslint-disable-next-line max-len  -->
        <p>Mida con una regla las barras horizontal (verde) y vertical (azul) e introduzca el resultado en mm en sus lugares correspondientes, seguidamente pulse Guardar para aplicar la calibración</p>
      </div>
    </div>
    <div class="measure-scale-calibration__control">
      <Button
        :disabled="manualInputDisabled"
        class="measure-scale-calibration__save-button"
        @click="setDPC"
      >
        Guardar
      </Button>
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useStore} from 'vuex';
import {dpcFromScreenMeasure} from '@/util-scale';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';
// #region Props, Emits
const emit = defineEmits(['changeDpc']);
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const mmX = ref(null);
const mmY = ref(null);
const measureXRef = ref();
const measureYRef = ref();

const manualInputDisabled = computed(() => !mmX?.value || !mmY?.value);

const widthMeasureX = computed(() => {
  const width = parseInt(measureXRef?.value?.clientWidth);
  return !!width ? width : null;
});

const heightMeasureY = computed(() => {
  const height = parseInt(measureYRef?.value?.clientHeight);
  return !!height ? height : null;
});
// #endregion

// #region Functions
async function setDPC() {
  const mmXF = parseFloat(mmX?.value);
  const mmYF = parseFloat(mmY?.value);
  if (
    !!mmXF &&
    !!mmYF &&
    !!widthMeasureX?.value &&
    !!heightMeasureY?.value
  ) {
    const resCalcDPC = dpcFromScreenMeasure(
      mmXF,
      mmYF,
      widthMeasureX.value,
      heightMeasureY.value,
    );
    const {dppc: screenDPC} = resCalcDPC;
    await store.dispatch('map/setScreenDPC', {screenDPC}, {root: true});
    emit('changeDpc');
  }
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
@use "src/styles/base";

.measure-scale-calibration {
  &__container {
    width: 100%;
    display: flex;
    flex-flow: column;
    padding: 0 0.5rem;
  }
  @mixin input-style {
    display: block;
    font-weight: bold;
  }
  &__measure-x {
    display: flex;
    flex-direction: column;
    & .measure-x-dynamic {
      width: 100%;
      height: 20px;
      border-top: solid 1rem green;
    }
    & .label-x-dynamic {
      display: flex;
      flex-direction: row-reverse;
      margin-bottom: .5rem;
      & .measure_label_icon {
        font-size: 2rem;
      }
    }
    & .input-x-dynamic {
      color: green;
      max-width: 12rem;
      margin-right: 1rem;
      margin-left: auto;
      @include input-style();
    }
  }
  &__measure-y {
    display: flex;
    flex-direction: row;
    & .measure-y-dynamic {
      height: 30dvh;
      width: 20px;
      border-left: solid 1rem blue;
    }
    & .label-y-dynamic {
      display: flex;
      flex-direction: row;
      margin-bottom: .5rem;
      & .measure_label_icon {
        font-size: 2rem;
      }
    }
    & .input-y-dynamic {
      color: blue;
      max-height: 2rem;
      margin-bottom: 1rem;
      margin-top: auto;
      @include input-style();
    }
    &-help-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  &__help-container {
    padding: 1rem;
    max-width: 60%;
    align-self: center;
  }
  &__control {
    max-width: 10rem;
    max-height: 2rem;
    margin: 1rem auto;
    display: flex;
  }
  &__save-button {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
</style>
